export const Filter = {
  ProjectId: "projectId" as const,
  ProjectName: "projectName" as const,
  BusinessUnitId: "businessUnitId" as const,
  BusinessUnitName: "businessUnitName" as const,
  PersonId: "personId" as const,
  PersonName: "personName" as const,
  Period: "period" as const,
  ExcludeInvoiced: "excludeInvoiced" as const,
  CategoryId: "categoryId" as const,
  CategoryName: "categoryName" as const,
  OnlyIncludeHourlyIndividualBillingModel: "onlyIncludeHourlyIndividualBillingModel" as const,
  DateInterval: "dateInterval" as const,
  IncludeOnlyDeviations: "includeOnlyDeviations" as const,
}

export const CreateTimeReport = {
  PersonId: "personId" as const,
  PersonName: "personName" as const,
  ProjectId: "projectId" as const,
  ProjectName: "projectName" as const,
  YearAndMonth: "yearAndMonth" as const,
  FromDate: "fromDate" as const,
  ToDate: "toDate" as const,
  Comment: "comment" as const,
  DayHours: "dayHours" as const,
  FillDayHours: "fillDayHours" as const,
  RestrictDateRange: "restrictDateRange" as const,
  TotalHours: "totalHours" as const,
}

export const HoursByDay = {
  Id: "id" as const,
  Day: "day" as const,
  Hours: "hours" as const,
  IsInvoiced: "isInvoiced" as const,
  IsHoliday: "isHoliday" as const,
}

export const SumDescription = {
  Id: "id" as const,
  Sum: "sum" as const,
  Description: "description" as const,
}

export const WeeklyTimeReport = {
  WorkedHours: "workedHours" as const,
  Rows: "rows" as const,
  HeaderRow: "headerRow" as const,
  TableHeader: "tableHeader" as const,
  TimeReportSuggestions: "timeReportSuggestions" as const,
  DeviationSuggestions: "deviationSuggestions" as const,
  ProjectSuggestions: "projectSuggestions" as const,
  Holidays: "holidays" as const,
}

export const WeeklyTimeReportRow = {
  Id: "id" as const,
  Name: "name" as const,
  Monday: "monday" as const,
  Tuesday: "tuesday" as const,
  Wednesday: "wednesday" as const,
  Thursday: "thursday" as const,
  Friday: "friday" as const,
  Saturday: "saturday" as const,
  Sunday: "sunday" as const,
  ChildName: "childName" as const,
  Type: "type" as const,
  ProjectId: "projectId" as const,
  DeviationId: "deviationId" as const,
  DeviationType: "deviationType" as const,
  CustomName: "customName" as const,
  CustomDescription: "customDescription" as const,
  UniqueId: "uniqueId" as const,
  WeekLocks: "weekLocks" as const,
  IsInternal: "isInternal" as const,
  CategoryName: "categoryName" as const,
  CategoryId: "categoryId" as const,
  Comments: "comments" as const,
}

export const DayLockData = {
  DayName: "dayName" as const,
  IsLocked: "isLocked" as const,
}

export const WeekLockEntries = {
}

export const EditCompHours = {
  AddHours: "addHours" as const,
  TotalHours: "totalHours" as const,
}

export const InvoiceDocumentation = {
  HasUnattestedRecords: "hasUnattestedRecords" as const,
  Data: "data" as const,
}

export const CreateDeviationType = {
  Name: "name" as const,
  Comment: "comment" as const,
}

export const MonthlyTimeReport = {
  Rows: "rows" as const,
  HeaderRow: "headerRow" as const,
  TableHeader: "tableHeader" as const,
}

export const MonthlyTimeReportRow = {
  Id: "id" as const,
  Name: "name" as const,
  Type: "type" as const,
  ProjectId: "projectId" as const,
  CategoryId: "categoryId" as const,
  CategoryName: "categoryName" as const,
  DeviationId: "deviationId" as const,
  DeviationType: "deviationType" as const,
  UniqueId: "uniqueId" as const,
  IsInternal: "isInternal" as const,
  ChildName: "childName" as const,
  CustomName: "customName" as const,
  CustomDescription: "customDescription" as const,
}

export const MonthWeek = {
  WeekNumber: "weekNumber" as const,
  DisplayText: "displayText" as const,
}

export const WeekComments = {
  InternalMonday: "internalMonday" as const,
  ExternalMonday: "externalMonday" as const,
  InternalTuesday: "internalTuesday" as const,
}

